import { IHistoryItem, IHistoryListState } from 'entities/History/History.models';

export const historyListReducers = {
  setList: (state: IHistoryListState, payload: IHistoryItem[]) => ({ ...state, data: payload }),
  setLoading: (state: IHistoryListState, payload: boolean) => ({ ...state, loading: payload }),
};
